import React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";
import { DesignerGameStatusToLabel } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").DesignerGameStatus} props.status
 * @param {(status: import("@seabrookstudios/pitch2table-core").DesignerGameStatus) => void} props.onChange
 */
export const AdvanceIdeaStatusAlert = ({ gameId, status, onChange }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  if (status !== "Idea" || playTests.length === 0) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      action={
        <Button color="inherit" size="small" onClick={() => onChange("InDevelopmentEarly")}>
          Update
        </Button>
      }
    >
      This game has play tests. Do you want to move this from &quot;{DesignerGameStatusToLabel.Idea}&quot; to &quot;
      {DesignerGameStatusToLabel.InDevelopmentEarly}&quot;?
    </Alert>
  );
};
